import { apiUrls } from 'consts'
import { useEffect } from 'react'
import getAll from 'utils/getAll'
import loadRecord from './../utils/loadRecord'

interface useInitProps {
  getValues: Function
  id: string | undefined
  reset: Function
  setDataLoaded: Function
  setShowOverlay: Function
  setManufacturers: Function
}

const useInit = (props: useInitProps) => {
  useEffect(() => {
    getAll(apiUrls.manufacturers).then((data) => props.setManufacturers(data))
    // fetch the device if edit
    if (props.id !== undefined) {
      loadRecord(apiUrls.models, props.id).then((data) => {
        props.reset(data)

        props.setDataLoaded(true)
        props.setShowOverlay(false)
      })
    } else {
      props.setDataLoaded(true)
      props.setShowOverlay(false)
    }
  }, [])
}

export default useInit
